/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";

export enum HasLuggage {
  LuggageUnknown = "LuggageUnknown",
  Included = "Included",
  Excluded = "Excluded",
}

export function hasLuggageFromJSON(object: any): HasLuggage {
  switch (object) {
    case 0:
    case "LuggageUnknown":
      return HasLuggage.LuggageUnknown;
    case 1:
    case "Included":
      return HasLuggage.Included;
    case 2:
    case "Excluded":
      return HasLuggage.Excluded;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum HasLuggage"
      );
  }
}

export function hasLuggageToJSON(object: HasLuggage): string {
  switch (object) {
    case HasLuggage.LuggageUnknown:
      return "LuggageUnknown";
    case HasLuggage.Included:
      return "Included";
    case HasLuggage.Excluded:
      return "Excluded";
    default:
      return "UNKNOWN";
  }
}

export function hasLuggageToNumber(object: HasLuggage): number {
  switch (object) {
    case HasLuggage.LuggageUnknown:
      return 0;
    case HasLuggage.Included:
      return 1;
    case HasLuggage.Excluded:
      return 2;
    default:
      return 0;
  }
}

export interface LuggageItem {
  weight: number;
  dimension?: Dimension;
}

export interface Dimension {
  width: number;
  height: number;
  depth: number;
  total: number;
}

export interface LuggageInfo {
  information: string;
  adultHoldItem?: LuggageItem;
  cabinItem?: LuggageItem;
  infantHoldItem?: LuggageItem;
}

function createBaseLuggageItem(): LuggageItem {
  return { weight: 0, dimension: undefined };
}

export const LuggageItem = {
  encode(
    message: LuggageItem,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.weight !== 0) {
      writer.uint32(13).float(message.weight);
    }
    if (message.dimension !== undefined) {
      Dimension.encode(message.dimension, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LuggageItem {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLuggageItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.weight = reader.float();
          break;
        case 2:
          message.dimension = Dimension.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): LuggageItem {
    return {
      weight: isSet(object.weight) ? Number(object.weight) : 0,
      dimension: isSet(object.dimension)
        ? Dimension.fromJSON(object.dimension)
        : undefined,
    };
  },

  toJSON(message: LuggageItem): unknown {
    const obj: any = {};
    message.weight !== undefined && (obj.weight = message.weight);
    message.dimension !== undefined &&
      (obj.dimension = message.dimension
        ? Dimension.toJSON(message.dimension)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<LuggageItem>): LuggageItem {
    const message = createBaseLuggageItem();
    message.weight = object.weight ?? 0;
    message.dimension =
      object.dimension !== undefined && object.dimension !== null
        ? Dimension.fromPartial(object.dimension)
        : undefined;
    return message;
  },
};

function createBaseDimension(): Dimension {
  return { width: 0, height: 0, depth: 0, total: 0 };
}

export const Dimension = {
  encode(
    message: Dimension,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.width !== 0) {
      writer.uint32(13).float(message.width);
    }
    if (message.height !== 0) {
      writer.uint32(21).float(message.height);
    }
    if (message.depth !== 0) {
      writer.uint32(29).float(message.depth);
    }
    if (message.total !== 0) {
      writer.uint32(37).float(message.total);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Dimension {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDimension();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.width = reader.float();
          break;
        case 2:
          message.height = reader.float();
          break;
        case 3:
          message.depth = reader.float();
          break;
        case 4:
          message.total = reader.float();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): Dimension {
    return {
      width: isSet(object.width) ? Number(object.width) : 0,
      height: isSet(object.height) ? Number(object.height) : 0,
      depth: isSet(object.depth) ? Number(object.depth) : 0,
      total: isSet(object.total) ? Number(object.total) : 0,
    };
  },

  toJSON(message: Dimension): unknown {
    const obj: any = {};
    message.width !== undefined && (obj.width = message.width);
    message.height !== undefined && (obj.height = message.height);
    message.depth !== undefined && (obj.depth = message.depth);
    message.total !== undefined && (obj.total = message.total);
    return obj;
  },

  fromPartial(object: DeepPartial<Dimension>): Dimension {
    const message = createBaseDimension();
    message.width = object.width ?? 0;
    message.height = object.height ?? 0;
    message.depth = object.depth ?? 0;
    message.total = object.total ?? 0;
    return message;
  },
};

function createBaseLuggageInfo(): LuggageInfo {
  return {
    information: "",
    adultHoldItem: undefined,
    cabinItem: undefined,
    infantHoldItem: undefined,
  };
}

export const LuggageInfo = {
  encode(
    message: LuggageInfo,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.information !== "") {
      writer.uint32(18).string(message.information);
    }
    if (message.adultHoldItem !== undefined) {
      LuggageItem.encode(
        message.adultHoldItem,
        writer.uint32(26).fork()
      ).ldelim();
    }
    if (message.cabinItem !== undefined) {
      LuggageItem.encode(message.cabinItem, writer.uint32(34).fork()).ldelim();
    }
    if (message.infantHoldItem !== undefined) {
      LuggageItem.encode(
        message.infantHoldItem,
        writer.uint32(42).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LuggageInfo {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLuggageInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          message.information = reader.string();
          break;
        case 3:
          message.adultHoldItem = LuggageItem.decode(reader, reader.uint32());
          break;
        case 4:
          message.cabinItem = LuggageItem.decode(reader, reader.uint32());
          break;
        case 5:
          message.infantHoldItem = LuggageItem.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): LuggageInfo {
    return {
      information: isSet(object.information) ? String(object.information) : "",
      adultHoldItem: isSet(object.adultHoldItem)
        ? LuggageItem.fromJSON(object.adultHoldItem)
        : undefined,
      cabinItem: isSet(object.cabinItem)
        ? LuggageItem.fromJSON(object.cabinItem)
        : undefined,
      infantHoldItem: isSet(object.infantHoldItem)
        ? LuggageItem.fromJSON(object.infantHoldItem)
        : undefined,
    };
  },

  toJSON(message: LuggageInfo): unknown {
    const obj: any = {};
    message.information !== undefined &&
      (obj.information = message.information);
    message.adultHoldItem !== undefined &&
      (obj.adultHoldItem = message.adultHoldItem
        ? LuggageItem.toJSON(message.adultHoldItem)
        : undefined);
    message.cabinItem !== undefined &&
      (obj.cabinItem = message.cabinItem
        ? LuggageItem.toJSON(message.cabinItem)
        : undefined);
    message.infantHoldItem !== undefined &&
      (obj.infantHoldItem = message.infantHoldItem
        ? LuggageItem.toJSON(message.infantHoldItem)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<LuggageInfo>): LuggageInfo {
    const message = createBaseLuggageInfo();
    message.information = object.information ?? "";
    message.adultHoldItem =
      object.adultHoldItem !== undefined && object.adultHoldItem !== null
        ? LuggageItem.fromPartial(object.adultHoldItem)
        : undefined;
    message.cabinItem =
      object.cabinItem !== undefined && object.cabinItem !== null
        ? LuggageItem.fromPartial(object.cabinItem)
        : undefined;
    message.infantHoldItem =
      object.infantHoldItem !== undefined && object.infantHoldItem !== null
        ? LuggageItem.fromPartial(object.infantHoldItem)
        : undefined;
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
